<div style="text-align:center">
    <img width="60%"  src="../assets/lavori.png">

</div>